import { render, staticRenderFns } from "./LTable.vue?vue&type=template&id=21c32074&scoped=true&"
import script from "./LTable.vue?vue&type=script&lang=js&"
export * from "./LTable.vue?vue&type=script&lang=js&"
import style0 from "./LTable.vue?vue&type=style&index=0&id=21c32074&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c32074",
  null
  
)

export default component.exports